import type * as type from "@vTypes";

export type WorkType = "근무" | "공가" | "휴가";

export type SlotOption = {
  readonly label: string;
  readonly value: number;
  readonly shiftGb: string | null;
};

export const WORK_TYPES = ["근무", "공가", "휴가"] as const;

export const SLOT_OPTIONS: readonly SlotOption[] = [
  { label: "-", value: 0, shiftGb: null },
  { label: "데이", value: 1, shiftGb: "데이" },
  { label: "이브닝", value: 2, shiftGb: "이브닝" },
  { label: "나이트", value: 3, shiftGb: "나이트" },
  { label: "고정근무", value: 4, shiftGb: "고정" },
] as const;

export function isWorkType(value: string): value is WorkType {
  return WORK_TYPES.some((item) => item === value);
}

function normalizeShiftManage(list: type.ShiftManageObject[]) {
  return list
    .map((item) => ({
      ...item,
      codes: [...item.codes].sort(),
    }))
    .sort((a, b) => a.shift_slot - b.shift_slot);
}

export function isSameShiftManage(
  left: type.ShiftManageObject[],
  right: type.ShiftManageObject[]
) {
  return (
    JSON.stringify(normalizeShiftManage(left)) ===
    JSON.stringify(normalizeShiftManage(right))
  );
}

export function nextShiftManage(
  currentShiftManage: type.ShiftManageObject[],
  shiftId: string,
  slotIndex: number
) {
  return currentShiftManage.map((item) => {
    const codes = item.codes.filter((code) => code !== shiftId);
    if (item.shift_slot === slotIndex && slotIndex > 0) {
      return { ...item, codes: [...codes, shiftId] };
    }
    return { ...item, codes };
  });
}

export function nextEditedShiftManage(
  currentShiftManage: type.ShiftManageObject[],
  previousShiftId: string,
  nextShiftId: string,
  slotIndex: number
) {
  return currentShiftManage.map((item) => {
    const codes = item.codes.filter(
      (code) => code !== previousShiftId && code !== nextShiftId
    );
    if (item.shift_slot === slotIndex && slotIndex > 0) {
      return { ...item, codes: [...codes, nextShiftId] };
    }
    return { ...item, codes };
  });
}

export function canUseOffSwapTarget(
  shift: {
    readonly type: string;
    readonly default_shift?: string | null;
    readonly shift_gb?: string | null;
  },
  offSwapOffShiftGb?: string | null
) {
  return (
    shift.type !== "근무" &&
    shift.default_shift !== "O" &&
    !(offSwapOffShiftGb && shift.shift_gb === offSwapOffShiftGb)
  );
}
